module.exports = __webpack_public_path__ + "static/logo-67d0dabff3134fab893bb3fdb1859065.svg";